import React from "react";
import { motion } from "framer-motion";

export const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const fadeIn = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 1.1, ease: [0.22, 1, 0.36, 1] } },
};

// Reveal wrapper: fades in on scroll down AND fades out on scroll up (once:false)
export const Reveal = ({ children, className = "", delay = 0, y = 40, testid }) => (
  <motion.div
    data-testid={testid}
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y }}
    viewport={{ amount: 0.2, margin: "-80px 0px -80px 0px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Stagger = ({ children, className = "", testid }) => (
  <motion.div
    data-testid={testid}
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ amount: 0.15, margin: "-80px 0px -80px 0px" }}
    variants={{ show: { transition: { staggerChildren: 0.08 } } }}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = "", y = 40 }) => (
  <motion.div
    className={className}
    variants={{
      hidden: { opacity: 0, y },
      show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } },
    }}
  >
    {children}
  </motion.div>
);
